class AliceMessage {
  constructor(
    id: $TSFixMe,
    itemId: $TSFixMe,
    moduleId: $TSFixMe,
    week: $TSFixMe,
    title: $TSFixMe,
    message: $TSFixMe,
    dataSourceDescription: $TSFixMe,
    action: $TSFixMe,
    epicToShowNamespace: $TSFixMe,
    epicToShowParameter: $TSFixMe,
    event: $TSFixMe
  ) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'AliceMessage... Remove this comment to see the full error message
    this.id = id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'itemId' does not exist on type 'AliceMes... Remove this comment to see the full error message
    this.itemId = itemId;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'moduleId' does not exist on type 'AliceM... Remove this comment to see the full error message
    this.moduleId = moduleId;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'week' does not exist on type 'AliceMessa... Remove this comment to see the full error message
    this.week = week;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'AliceMess... Remove this comment to see the full error message
    this.title = title;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'message' does not exist on type 'AliceMe... Remove this comment to see the full error message
    this.message = message;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'dataSourceDescription' does not exist on... Remove this comment to see the full error message
    this.dataSourceDescription = dataSourceDescription;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'action' does not exist on type 'AliceMes... Remove this comment to see the full error message
    this.action = action;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'epicToShowNamespace' does not exist on t... Remove this comment to see the full error message
    this.epicToShowNamespace = epicToShowNamespace;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'epicToShowParameter' does not exist on t... Remove this comment to see the full error message
    this.epicToShowParameter = epicToShowParameter;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'event' does not exist on type 'AliceMess... Remove this comment to see the full error message
    this.event = event;
  }
}

export default AliceMessage;
